<script>

import CopyToClipboard from './CopyToClipboard'
import VJsoneditor from 'v-jsoneditor/src/index'

export default {
  components: {
    CopyToClipboard,
    VJsoneditor
  },

  props: {
    value: {
      type: Object
    },

    autoclose: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    apply() {
      if (this.jsonError) { return }

      this.$emit('input', this.json)
      if (this.autoclose) {
        this.$emit('cancel')
      }
    }
  },

  computed: {
    jsonString() {
      return JSON.stringify(this.json, null, 4)
    }
  },

  data() {
    return {
      json: this.value,
      jsonError: false,

      editorOptions: {
        "mode": "code"
      }
    }
  }

}
</script>

<template>
  <div>

    <v-jsoneditor v-model="json" :options="editorOptions" :plus="false" height="400px" @error="jsonError = true" @input="jsonError = false">
    </v-jsoneditor>

    <p class="has-text-danger is-size-7" role="alert">
      <span v-if="jsonError">
        Please take a look at the errors above.
      </span>
      <span v-else>&nbsp;</span>
    </p>

    <div class="buttons">
      <copy-to-clipboard title="Copy JSON" :content="jsonString">Copy JSON</copy-to-clipboard>
      <b-button class="is-pulled-right" type="is-primary" :disabled="jsonError" @click="apply">Apply changes</b-button>
    </div>
  </div>
</template>

<style lang="scss">
@import "~bulma/sass/utilities/initial-variables";

div.jsoneditor {
  border: thin solid $grey-light;
}
div.jsoneditor-menu {
  background-color: $grey-light;
  border-bottom: 1px solid $grey-light;
}
</style>